import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';

class LottieLoader extends Component {
  constructor(props) {
    super(props);
    this.loaderRef = React.createRef();
  }

  componentDidMount() {
    lottie.loadAnimation({
      container: this.loaderRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/static/loader.json'
    });
  }

  render() {
    const { height, fit } = this.props;
    return (
      <div
        style={height ? { minHeight: `${height}px`, height: 'auto' } : null}
        className={`fe-loading-container ${fit ? 'fit' : ''}`}
      >
        <div ref={this.loaderRef} className='fe-loader' />
      </div>
    );
  }
}

LottieLoader.propTypes = {
  fit: PropTypes.bool.isRequired,
  height: PropTypes.number
};

LottieLoader.defaultProps = {
  fit: false
};

export default LottieLoader;
